export default "__VITE_ASSET__BA3RbRaJ__"